import { useQuery } from '@tanstack/react-query';
import { Property } from 'shared-types/Property';
import { getAnnouncements } from './requests';

export const announcementsKeys = {
  announcements: ['announcements'] as const,
  announcementsByProperty: (propertySlug: string, language?: string) =>
    [...announcementsKeys.announcements, propertySlug, language ?? 'default'] as const,
};

export function useAnnouncements(slug: Property['slug'], language?: string) {
  return useQuery({
    queryKey: announcementsKeys.announcementsByProperty(slug, language),
    queryFn: () => getAnnouncements(slug, language),
  });
}
